import React from "react";
import { Typography } from "@material-ui/core";

export default function LimitInfo({ limit }) {
  if (!limit) {
    return null;
  }

  const isFull = limit.used >= limit.limit;
  return (
    <Typography
      variant="body2"
      color={isFull ? "error" : "textSecondary"}
      style={{ marginBottom: 10 }}
    >
      {"Kullanılan Limit: " +
        limit.used +
        " / " +
        limit.limit +
        (isFull ? " (limit doldu, yeni kayıt eklenemez)" : "")}
    </Typography>
  );
}
